import { DataReviewJob } from "../../types/dataReview";

/** Where the cut-off starts for a pass; the same number as the backend's. */
export const DEFAULT_THRESHOLD = 35;

export const thresholdKey = (jobId: number, pass: number) => `${jobId}:${pass}`;

/** How sure a finding from this pass must be to count: the slider's value
 *  if it has been moved here, else what the run has saved. */
export const passThreshold = (job: DataReviewJob | null | undefined, pass: number, overrides: Record<string, number>) => {
  if (job) {
    const local = overrides[thresholdKey(job.id, pass)];
    if (local !== undefined) return local;
    const saved = (job.stats?.thresholds as Record<string, number> | undefined)?.[String(pass)];
    if (saved !== undefined) return Number(saved);
  }
  return DEFAULT_THRESHOLD;
};
